'use strict';
export default {
    'title': {
        'en': 'Omniva e-service',
        'et': 'Omniva e-teenindus',
        'ru': 'Omniva e-service',
        'lv': 'Omniva e-service',
        'lt': 'Omniva e-service'
    },
    'lang.et': {
        'en': 'Eesti',
        'et': 'Eesti',
        'ru': 'Эстония',
        'lv': 'Igaunija',
        'lt': 'Estija'
    },
    'lang.en': {
        'en': 'English',
        'et': 'English'
    },
    'edit': {
        'en': 'Edit',
        'et': 'Muuda',
        'ru': 'Изменить',
        'lv': 'Mainīt',
        'lt': 'Pakeisti'
    },
    'delete': {
        'en': 'Delete',
        'et': 'Kustutan',
        'ru': 'Удалить',
        'lv': 'Dzēst',
        'lt': 'Pašalinti'
    },
    'save': {
        'en': 'Save',
        'et': 'Salvestan',
        'ru': 'Сохранить',
        'lv': 'Saglabāt',
        'lt': 'Išsaugoti'
    },
    'cancel': {
        'en': 'Cancel',
        'et': 'Katkestan',
        'ru': 'Отменить',
        'lv': 'Pārtraukt',
        'lt': 'Nutraukti'
    },
    'choose': {
        'en': 'Choose',
        'et': 'Valin',
        'ru': 'Выбрать',
        'lv': 'Izvēlēties',
        'lt': 'Pasirinkti'
    },
    'help': {
        'en': 'Help',
        'et': 'Abiinfo',
        'ru': 'Вспомогательная информация',
        'lv': 'Palīginformācija',
        'lt': 'Pagalbinė informacija'
    },
    'optional': {
        'en': 'optional',
        'et': 'mittekohustuslik',
        'ru': 'Необязательный',
        'lv': 'Neobligāts',
        'lt': 'Nebūtinas'
    },
    'e-mail': {
        'en': 'E-mail',
        'et': 'E-post',
        'ru': 'Электронная почта',
        'lv': 'E-pasts',
        'lt': 'El. paštas'
    },
    'add-another': {
        'en': 'Add another',
        'et': 'Lisan veel ühe',
        'ru': 'Добавить еще одного',
        'lv': 'Pievienot vēl vienu',
        'lt': 'Pridėti dar vieną'
    },
    'change': {
        'en': 'Change',
        'et': 'Muuda',
        'ru': 'Изменить',
        'lv': 'Mainīt',
        'lt': 'Pakeisti'
    },
    'close': {
        'en': 'Close',
        'et': 'Sulgen',
        'ru': 'Закрыть',
        'lv': 'Aizvērt',
        'lt': 'Uždaryti'
    },
    'continue': {
        'en': 'Continue',
        'et': 'Jätkan',
        'ru': 'Продолжить',
        'lv': 'Turpināt',
        'lt': 'Tęsti'
    },
    'yes': {
        'en': 'Yes',
        'et': 'Jah',
        'ru': 'Да',
        'lv': 'Jā',
        'lt': 'Taip'
    },
    'no': {
        'en': 'No',
        'et': 'Ei',
        'ru': 'Нет',
        'lv': 'Nē',
        'lt': 'Ne'
    },
    'success.save': {
        'en': 'Save successful',
        'et': 'Salvestamine õnnestus',
        'ru': 'Сохранение удалось',
        'lv': 'Saglabāšana izdevās',
        'lt': 'Išsaugota sėkmingai'
    },
    'error.required': {
        'en': '%s is mandatory',
        'et': '%s on kohustuslik',
        'ru': '%s является обязательным',
        'lv': '%s ir obligāts',
        'lt': '%s yra privalomas'
    },
    'error.minlength': {
        'en': 'Field length is below allowed limit',
        'et': 'Välja pikkus on alla lubatud piiri'
    },
    'error.email': {
        'en': 'The e-mail address does not meet the standard. Please verify that your email address has the proper format: nimi@aadress.ee',
        'et': 'E-post ei vasta standardile. Palun kontrolli, kas sisestasid e-posti aadressi õiges formaadis: nimi@aadress.ee',
        'ru': 'Электронная почта не соответствуют стандарту. Пожалуйста, убедитесь, ввели ли вы ​​адрес электронной почты в правильном формате: nimi@aadress.ee',
        'lv': 'E-pasts neatbilst standartam. Lūdzu, pārbaudiet, vai e-pasta adresi ievadījāt atbilstoši formātam: vārds@adrese.lv',
        'lt': 'El. paštas neatitinka standartų. Prašome patikrinti, ar el. pašto adresas įvestas teisinga forma: nimi@aadress.lt'
    },
    'error.url': {
        'en': 'Invalid webpage address',
        'et': 'Veebilehe aadressi formaat ei vasta nõuetele',
        'ru': 'Формат адреса веб-страницы не соответствует требованиям',
        'lv': 'Tīmekļa vietnes adreses formāts neatbilst prasībām',
        'lt': 'Internetinio puslapio adreso formatas neatitinka reikalavimų'
    },
    'error.phone': {
        'en': 'Invalid phone number',
        'et': 'Telefoninumbri formaat ei vasta nõuetele',
        'ru': 'Формат номера телефона не соответствует требованиям',
        'lv': 'Tālruņa numura formāts neatbilst prasībām',
        'lt': 'Telefono numerio formatas neatitinka reikalavimų'
    },
    'error.max-length': {
        'en': 'The maximum length of "%s" is %d characters',
        'et': 'Välja "%s" maksimaalne pikkus tohib olla %d tähemärki',
        'ru': 'Максимальная длина поля "%s" может быть %d символов',
        'lv': 'Lauka "%s" maksimālais garums var būt %d simboli',
        'lt': 'Didžiausias lauko "%s" ilgis gali būti %d simbolių'
    },
    'error.password': {
        'en': 'The password must consist of at least 8 characters, include uppercase and lowercase letters and at least one number.',
        'et': 'Salasõna peab koosnema vähemalt 8 tähemärgist, sisaldama suuri ja väikeseid tähti ning vähemalt ühte numbrit.',
        'ru': 'Пароль должен состоять минимум из 8 символов, включать заглавные и прописные буквы и минимум одну цифру.',
        'lv': 'Parolei ir jābūt no vismaz 8 rakstzīmēm, jāietver lielos un mazos burtus un vismaz vienu ciparu.',
        'lt': 'Slaptažodis turi būti mažiausiai iš 8 ženklų, įskaitant didžiąsias bei mažąsias raides, ir mažiausiai vieno skaičiaus.'
    },
    'error.server': {
        'en': 'Error occured during request. Please check input data or try again later',
        'et': 'Päringu sooritamisel tekkis viga. Palun kontrolli sisendandmete korrektsust või proovi hiljem uuesti',
        'ru': 'При выполнении запроса возникла ошибка. Пожалуйста, проверь корректность вводимых данных или попробуй еще раз позже',
        'lv': 'Pieprasījuma izpildes laikā radās kļūda. Lūdzu, pārbaudi ievadāmo datu pareizību vai mēģini vēlāk vēlreiz',
        'lt': 'Vykdant užklausą atsirado klaida. Prašome patikrinti įvedamų duomenų teisingumą arba bandykite dar kartą vėliau'
    },
    'error.signature': {
        'en': 'Error occured during signing process',
        'et': 'Viga allkirjastamisel',
        'ru': 'Error occured during signing process',
        'lv': 'Error occured during signing process',
        'lt': 'Error occured during signing process'
    },
    'error.unique': {
        'en': 'Username is already in use',
        'et': 'Kasutajanimi on juba kasutusel',
        'ru': 'Имя пользователя уже используется',
        'lv': 'Lietotāja vārds jau tiek izmantots',
        'lt': 'Toks vartotojo vardas jau naudojamas'
    },
    'error.synced': {
        'en': 'Passwords entered do not match. Please enter them again.',
        'et': 'Sisestatud salasõnad ei ole samasugused. Palun sisesta salasõnad uuesti.',
        'ru': 'Введенные пароли не совпадают. Пожалуйста, введите пароли снова.',
        'lv': 'Ievadītās paroles nav vienādas. Lūdzu, ievadiet paroles vēlreiz.',
        'lt': 'Įvestas slaptažodis yra ne tas pats. Prašome įvesti slaptažodį iš naujo.'
    },
    'error.client': {
        'en': 'Service is disrupted, please try again later',
        'et': 'Teenuse töös esinevad tõrked, proovi hiljem uuesti',
        'ru': 'В работе услуг возникли неполадки, попробуй позже снова',
        'lv': 'Pakalpojumu darbībā radušās kļūmes, mēģini vēlāk vēlreiz',
        'lt': 'Sutrikimai paslaugų teikimo darbe, bandykite dar kartą vėliau'
    },
    'error.person-code': {
        'en': 'The national identification number you entered is not valid in this country. Please enter the correct number.',
        'et': 'Sisestatud isikukood ei ole valitud riigis kehtiv. Palun kontrolli, kas sisestasid koodi õigesti.',
        'ru': 'Введенный идентификационный код личности в выбранной стране отсутствует. Пожалуйста, проверьте правильность введенного кода.',
        'lv': 'Personas kods, kuru Jūs ievadījāt, nav derīgs attiecīgajā valstī. Lūdzu, mēģiniet vēlreiz.',
        'lt': 'Jūsų ID numeris negalioja šioje šalyje. Prašome įvesti teisingą numerį.'
    },
    'error.address': {
        'en': 'Address incorrect',
        'et': 'Sisestatud aadress pole korrektne'
    },
    'error.pattern': {
        'en': 'Invalid value',
        'et': 'Vigane väärtus'
    },
    'error.daterange': {
        'en': 'From date must be before end date',
        'et': 'Alguskuupäev peab olema lõpukuupäevast varasem',
        'ru': 'Начальная дата должна быть раньше конечной даты',
        'lv': 'Sākuma datumam jābūt pirms beigu datuma',
        'lt': 'Pirminė data turi būti ankstesnė už galutinę datą'
    },
    'error.username': {
        'en': 'Username can only contain letters, numbers and a period',
        'et': 'Kasutajanimi tohib sisaldada ainult tähti, numbreid ja punkti',
        'ru': 'Имя пользователя может содержать только буквы, числа и точку',
        'lv': 'Lietotāja vārdā var būt tikai burti, skaitļi un punkts',
        'lt': 'Vartotojo vardas turi turėti tik raides, skaičiai ir tašką'
    },
    'error.auth': {
        'en': 'No rights to access components',
        'et': 'Komponendi nägemiseks puuduvad õigused',
        'ru': 'Отсутствуют права, чтобы увидеть компонент',
        'lv': 'Nav tiesību skatīt komponenti',
        'lt': 'Nesuteikta teisė šiam elementui matyti'
    },

    'error.representation-failure': {
        'et': 'Hetkel ei ole %s kättesaadav. Proovi mõne aja pärast välja ning seejärel uuesti sisse logida. Palume vabandust võimalike ebamugavuste pärast.',
        'en': 'The %s is/are not available at the moment. After a while, please try to log out and log back in. We apologize for any inconvenience.',
        'ru': '%s не доступна(ы) в данный момент. Через некоторое время, попробуй выйти и войти обратно. Приносим свои извинения за причиненные неудобства.',
        'lv': '%s ir / nav pieejams šobrīd. Vēlāk mēģiniet atslēgties un pieslēgties vēlreiz. Atvainojamies par sagādātajām neērtībām.',
        'lt': 'Deja, šiuo metu siuntų %s dėl techninių priežasčių neveikia. Pamėginkite atsijungti ir prisijungti iš naujo vėliau. Nuoširdžiai atsiprašome už sukeltus nepatogumus.'
    },
    'error.service.EAK': {
        'et': 'Arvete haldus',
        'en': 'Invoicing management',
        'ru': 'Управление счетами',
        'lv': 'Rēķinu administrācija',
        'lt': 'Sąskaitų tvarkymas'
    },

    'error.service.recovered.autorefresh.EAK': {
        'et':'Arvete haldus teenus on taastunud, iseteenindus värskendab end 10 sekundi pärast'
    },
    'error.service.recovered.refresh.EAK': {
        'et':'Arvete haldus teenus on taastunud, enne teenuse kasutamist on vajalik veebilehte värskendada'
    },

    'error.axapta.dead': {
        'et': 'Iseteeninduse töös esineb tõrkeid ja hetkel ei ole võimalik seadeid vaadata/muuta ning sõlmida uut ärikliendi lepingut.',
        'en': 'You may encounter disruptions in self-service operations, therefore, it is currently not possible to see/change settings or sign a new business client contract.',
        'ru': 'Произошел сбой системы самообслуживания, в настоящий момент невозможно просмотреть/изменить настройки, а также заключить новый договор коммерческого клиента.',
        'lv': 'Ir radusies kļūme pašapkalpošanās sistēmā un šobrīd nav iespējams pārlūkot/mainīt iestatījumus, kā arī noslēgt jaunu komercklienta līgumu.',
        'lt': 'Sugedo savitarnos sistema, šiuo metu neįmanoma peržiūrėti/pakeisti nustatymų bei sudaryti naują komercinio kliento sutartį.',
    },

    'pager.total': {
        'en': 'Total',
        'et': 'Kokku',
        'ru': 'Всего',
        'lv': 'Kopā',
        'lt': 'Viso'
    },
    'pager.showing': {
        'en': 'Showing',
        'et': 'Näitan',
        'ru': 'Показываю',
        'lv': 'Rādu',
        'lt': 'Rodau'
    },
    'pager.first': {
        'en': 'First',
        'et': 'Esimene',
        'ru': 'Первая',
        'lv': 'Pirmā',
        'lt': 'Pirma'
    },
    'pager.last': {
        'en': 'Last',
        'et': 'Viimane',
        'ru': 'Последняя',
        'lv': 'Pēdējā',
        'lt': 'Paskutinė'
    },
    'pager.next': {
        'en': 'Next',
        'et': 'Järgmine',
        'ru': 'Следующая',
        'lv': 'Nākamā',
        'lt': 'Sekanti'
    },
    'pager.prev': {
        'en': 'Previous',
        'et': 'Eelmine',
        'ru': 'Предыдущая',
        'lv': 'Iepriekšējā',
        'lt': 'Prieš tai buvusi'
    },
    'filter': {
        'en': 'Filter',
        'et': 'Filtreeri',
        'ru': 'Фильтровать',
        'lv': 'Filtrēt',
        'lt': 'Filtruoti'
    },
    'homepage': {
        'en': 'Homepage',
        'et': 'Avaleht',
        'ru': 'Сайт',
        'lv': 'Mājaslapa',
        'lt': 'Internetinis puslapis'
    },
    'address-not-found': {
        'en': "Didn't find your address?",
        'et': 'Ei leidnud oma aadressi?',
        'ru': 'Не могу найти правильный адрес',
        'lv': 'Netiek atrasta pareizā adrese',
        'lt': 'Teisingas adresas nerastas'
    },
    /* COUNTRIES-> */
    'country.EE': {
        'en': 'Estonia',
        'et': 'Eesti',
        'ru': 'Эстония',
        'lv': 'Igaunija',
        'lt': 'Estija'
    },
    'country.LV': {
        'en': "Latvia",
        'et': 'Läti',
        'ru': 'Латвия',
        'lv': 'Latvija',
        'lt': 'Latvija'
    },
    'country.LT': {
        'en': "Lithuania",
        'et': 'Leedu',
        'ru': 'Литва',
        'lv': 'Lietuva',
        'lt': 'Lietuva'
    },
    'country.ZZ': {
        'en': 'Other',
        'et': 'Muu',
        'ru': 'Другое',
        'lv': 'Cita',
        'lt': 'Kita'
    },
    /* <-COUNTRIES */
    /* ADDRESS COMPONENT-> */
    'address.placeholder': {
        'en': 'Street, house number, apartment, village, rural municipality, town',
        'et': 'Tänav, maja, korter, küla, vald, linn',
        'ru': 'Улица, дом, квартира, деревня, волость, город',
        'lv': 'Iela, māja, dzīvoklis, ciems, pagasts, pilsēta',
        'lt': 'Gatvė, namas, butas, kaimas, savivaldybė, miestas'
    },
    'address.desc': {
        'en': 'Enter the name of the street and the house number or the name of the farm. Then select the proper address from the generated list. If this address is not in the list, add the name of the town, village or township to the previously entered information and try again.',
        'et': 'Sisesta tänava nimi ja maja number või talu nimetus. Seejärel vali tekkinud nimekirjast õige aadress. Kui nimekirja sobivat aadressi ei tekkinud, lisa juba sisestatud infole linna või küla ja valla nimetus ning proovi uuesti.',
        'ru': 'Введите название улицы и номер дома или название хутора. Затем выберите из предложенного  списка правильный адрес. Если в списке нужный адрес не появился, введите правильное название города, деревни или поселка и повторите попытку.',
        'lv': 'Ievadiet ielas nosaukumu un mājas numuru, vai viensētas nosaukumu. Pēc tam no saraksta izvēlieties pareizo adresi. Ja sarakstā neparādās attiecīgā adrese, aizpildītajai informācijai pievienojiet pilsētas vai ciema un pagasta nosaukumu un mēģiniet vēlreiz.',
        'lt': 'Įveskite gatvės pavadinimą ir namo numerį arba ūkio pavadinimą. Tada iš pateikto sąrašo pasirinkite teisingą adresą. Jeigu sąraše nėra pateiktas tinkamas adresas, įtraukite dar į pateiktą informaciją miesto arba kaimo ir savivaldybės pavadinimą bei pabandykite iš naujo pasirinkti.'
    },
    'address.manual': {
        'en': 'If you cannot find the correct address, please enter it manually in the text boxes below.',
        'et': 'Kui Sa ei leia nimekirjast õiget aadressi, sisesta palun aadress käsitsi siia lahtritesse.',
        'ru': 'Если вы не можете найти в списке правильный адрес, пожалуйста, введите адрес вручную',
        'lv': 'Ja sarakstā neatrodat pareizo adresi, lūdzu, ievadiet to šajā lodziņā',
        'lt': 'Jei sąraše negalite rati teisingo adreso, prašome įvesti adresą rankiniu būdu čia į laukelį.'
    },
    'address.county': {
        'en': 'County',
        'et': 'Maakond',
        'ru': 'Уезд',
        'lv': 'Apriņķis',
        'lt': 'Apskritis'
    },
    'address.municipality': {
        'en': 'City / parish',
        'et': 'Linn / vald',
        'ru': 'Город / волость',
        'lv': 'Pilsēta / rajons',
        'lt': 'Miestas / savivaldybė'
    },
    'address.settlement': {
        'en': 'Settlement',
        'et': 'Asula',
        'ru': 'населенный пункт',
        'lv': 'apdzīvota vieta',
        'lt': 'miestelis'
    },
    'address.street': {
        'en': 'Street / house / apartment / farm',
        'et': 'Tänav / maja / korter / talu',
        'ru': 'Улица / дом / квартира /хутор',
        'lv': 'Iela / māja / dzīvoklis / viensēta',
        'lt': 'Gatvė / namas / butas / ūkis'
    },
    'address.zipCode': {
        'en': 'Postal code',
        'et': 'Sihtnumber',
        'ru': 'Почтовый индекс',
        'lv': 'Pasta indekss',
        'lt': 'Pašto indeksas'
    },
    /* <-ADDRESS COMPONENT */
    /* LANGUAGES-> */
    'lang.ET': {
        'en': "estonian",
        'et': 'eesti keel',
        'ru': 'эстонский',
        'lv': 'igauņu valoda',
        'lt': 'estų kalba'
    },
    'lang.LV': {
        'en': "latvian",
        'et': 'läti keel',
        'ru': 'латышский',
        'lv': 'latviešu valoda',
        'lt': 'latvių kalba'
    },
    'lang.LT': {
        'en': 'lithuanian',
        'et': 'leedu keel',
        'ru': 'литовский',
        'lv': 'lietuviešu valoda',
        'lt': 'lietuvių kalba'
    },
    'lang.RU': {
        'en': "russian",
        'et': 'vene keel',
        'ru': 'русский',
        'lv': 'krievu valoda',
        'lt': 'rusų kalba'
    },
    'lang.EN': {
        'en': "english",
        'et': 'inglise keel',
        'ru': 'английский',
        'lv': 'angļu valoda',
        'lt': 'anglų kalba'
    },
    /* <-LANGUAGES */
    'begin': {
        'en': 'Begin',
        'et': 'Algus',
        'ru': 'Начало',
        'lv': 'Sākums',
        'lt': 'Pradžia'
    },
    'end': {
        'en': 'End',
        'et': 'Lõpp',
        'ru': 'Конец',
        'lv': 'Beigas',
        'lt': 'Pabaiga'
    },
    'unlimited': {
        'en': 'unlimited',
        'et': 'tähtajatu',
        'ru': 'Бессрочный',
        'lv': 'Beztermiņa',
        'lt': 'Neterminuotas'
    },
    'not-active': {
        'en': 'inactive',
        'et': 'Mitteaktiivne',
        'ru': 'Неактивный',
        'lv': 'neaktīvs',
        'lt': 'neaktyvus'
    },
    'active': {
        'en': 'Active',
        'et': 'Aktiivne',
        'ru': 'Активный ',
        'lv': 'aktīvs',
        'lt': 'aktyvus'
    },
    /* +----------------------+ */
    /* +---+ Applications +---+ */
    /* +----------------------+ */
    'server.maintenance.title': {
        'en': 'Sorry!',
        'et': 'Vabandame!',
        'ru': 'Извините!',
        'lv': 'Atvainojiet!',
        'lt': 'Brangus kliente!'
    },
    'server.maintenance.desc': {
        'en': 'Due to technical issues, the functioning of our e-service is currently disrupted. We are working on a solution. We apologise for the inconvenience!',
        'et': 'Tehnilise rikke tõttu on hetkel meie e-teeninduse töö häiritud. Probleemi lahendamisega tegeletakse. Vabandame ebamugavuste pärast!',
        'ru': 'Из-за технических неполадок работа нашей системы э-обслуживания была нарушена. Мы работаем над решением. Приносим извинения за доставленные неудобства!',
        'lv': 'Tehnisku traucējumu dēļ, šobrīd mūsu e-servisa darbība ir ierobežota. Šobrīd strādājam pie risinājuma. Atvainojamies par sagādātajām neērtībām.',
        'lt': 'Dėl techninių sutrikimų šiuo metu neveikia mūsų elektroninės paslaugos. Mes ieškome sprendimą. Atsiprašome už nepatogumus!'
    },
    'menu': {
        'en': 'Menu',
        'et': 'Menüü',
        'ru': 'Меню',
        'lv': 'Izvēlne',
        'lt': 'Meniu'
    }
};


// WEBPACK FOOTER //
// ./src/main/ui/core/core.translations.ts